export default "__VITE_ASSET__1b679818__"